import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { company } from '~/company/Company';
import type { ProductViewProps } from '~/pages/Product/Product';
import { Offer } from '~/stores/CategoriesStore/Offer';
import { formatPriceWithCurrency } from '~/utils/formaters';

import styles from './ProductCustomsInfo.module.scss';

/**
 * Customs duty of the selected offer for cross-border goods. Rendered only
 * when the backend provides a customs fee. Parcel weight/dimensions are
 * intentionally omitted from the current product layout.
 */
const ProductCustomsInfo = ({
  currentItem,
  isLoading,
}: Pick<ProductViewProps, 'currentItem' | 'isLoading'>) => {
  const { t } = useTranslation();

  if (
    !company.showProductCustomsInfo ||
    isLoading ||
    !(currentItem instanceof Offer)
  ) {
    return null;
  }

  const { customsFee } = currentItem;

  const rows: Array<{ label: string; value: string }> = [];

  if (customsFee) {
    rows.push({
      label: t('customsDutiesFee'),
      value: formatPriceWithCurrency(customsFee / 100),
    });
  }

  if (!rows.length) {
    return null;
  }

  return (
    <div className={styles.root}>
      {rows.map(({ label, value }) => (
        <div key={label} className={styles.row}>
          <span className={styles.label}>{label}</span>
          <span className={styles.value}>{value}</span>
        </div>
      ))}
    </div>
  );
};

export default observer(ProductCustomsInfo);
